import UiInput from './ui/Input'
import { useLayoutEffect, useRef } from 'react'

// Keep typing local and preserve the DOM input used by Google Places.
export default function LocationSearchInput({ address, ...props }) {
    const inputRef = useRef(null)
    useLayoutEffect(() => {
        if (inputRef.current) inputRef.current.value = address.value || ''
    }, [address])
    return <UiInput {...props} ref={inputRef} defaultValue={address.value || ''} />
}
